import { getFeatureFlags } from '@noths/polaris-client-feature-flags';
import type { IncomingMessage } from 'http';

import { ClpPopulation, DeliveryCost, HighCommissionBoosting } from './featureFlags';

export const getFeatureFlagsWithMatchers = (req: IncomingMessage) => {
  return getFeatureFlags(req, {
    collapseFlagNames: [
      {
        newName: HighCommissionBoosting.NAME,
        oldNameMatcher: /^plp_hc_boosting/m,
      },
      {
        newName: ClpPopulation.NAME,
        oldNameMatcher: /^clp_population/m,
      },
      {
        newName: DeliveryCost.NAME,
        oldNameMatcher: /^plp_show_delivery_cost/m,
      },
    ],
  });
};
